import moment from 'moment';

export default class DateHelper {
    
    constructor() {
        throw 'Não é possível instanciar DateHelper';
    }

    static convertDateToNumber(dataPtbr) {
        let dataApi = moment(dataPtbr, 'DD/MM/YYYY').format('MMM DD, YYYY');
        dataApi = moment(dataApi).valueOf();
        return dataApi;
    }
    
    static convertNumberToDate(numero) {
        return moment(numero).format("DD/MMM/YYYY");
    }

    static convertDateToPtbr(date) {
        let testDateApi = /\d{4}-\d{2}-\d{2}/
        return testDateApi.test(date) ? 
            moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY') : date
    }

    static convertDateToApiDate(date) {
        return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    static convertPtbrToApiDate(dataPtbr) {
        let testDatePtbr = /\d{2}\/\d{2}\/\d{4}/
        return testDatePtbr.test(dataPtbr) ? 
            moment(dataPtbr, 'DD/MM/YYYY').format('YYYY-MM-DD') : dataPtbr
    }

    static tempoPorExtenso (anos, meses, dias) {
        let frase = ''
        let anosPalavra = ''
        let mesesPalavra = ''
        let diasPalavra = ''
        
        if (!anos) {
            anos = anosPalavra = '' 
        } else if (anos === 1) {
            anosPalavra = ' ano '
        } else {
            anosPalavra = ' anos '
        }

        if (!meses) {
            meses = mesesPalavra = ''
        } else if (meses === 1) {
            mesesPalavra = ' mês '
        } else {
            mesesPalavra = ' meses '
        }

        if (!dias) {
            dias = diasPalavra = ''
        } else if (dias === 1) {
            diasPalavra = ' dia '
        } else {
            diasPalavra = ' dias '
        }

        frase = anos + anosPalavra + meses + mesesPalavra + dias + diasPalavra

        return frase
    }

    /**
     * @param string data Data no formato ##/##/####
     */
    dataPorExtenso(data) {
        return `${data.split('/')[0]}/${this.mesPorExtenso(data.split('/')[1])}/${data.split('/')[2]}`
    }

    /**
     * @param int mes Mês de 1 a 12
     */
    mesPorExtenso(mes) {
        let meses = [
            'Janeiro',
            'Fevereiro',
            'Março',
            'Abril',
            'Maio',
            'Junho',
            'Julho',
            'Agosto',
            'Setembro',
            'Outubro',
            'Novembro',
            'Dezembro'
        ]
        return meses[mes - 1]
    }
}


// WEBPACK FOOTER //
// ./src/helpers/DateHelper.js